import { Route, lazyRouteComponent } from "@tanstack/react-router";
import {
  searchParamsSchema,
  reservationQueryOptions,
} from "../containers/reservation-overview";
import { rootRoute } from "./root";

export const manageReservationRoute = new Route({
  validateSearch: (search) => searchParamsSchema.parse(search),
  loaderDeps: ({ search: { reservationId } }) => ({
    reservationId,
  }),
  loader: (options) =>
    options.context.queryClient.ensureQueryData(
      reservationQueryOptions(options.deps),
    ),
  getParentRoute: () => rootRoute,
  path: "/manage-reservation",
  component: lazyRouteComponent(() => import("../pages/manage-reservation")),
});
